import Link from 'next/link';
import { FC, JSX } from 'react';

export const NAME = 'image-category-title-vertical';

type Props = {
  image?: string | null;
  title: string;
  alias: string;
  categories?: string[];
  titleTag?: string;
};

const ImageCategoryTitle: FC<Props> = ({ image, title, alias, categories, titleTag = 'h2' }) => {
  const TitleTag = titleTag as keyof JSX.IntrinsicElements;

  return (
    <div className="wp-block wp-block-group wp-block-group-is-layout-flex is-layout-flex is-vertical">
      {image && (
        <figure>
          {
            // eslint-disable-next-line @next/next/no-img-element
            <img src={image} alt="" />
          }
        </figure>
      )}
      <span className="category">{categories?.join(', ')}</span>
      <TitleTag>
        <Link href={alias}>{title}</Link>
      </TitleTag>
    </div>
  );
};

export default ImageCategoryTitle;
